import React from 'react';
import './Spinner.css';

export const Spinner = () => (
  <div className="cssload-container">
    <div className="cssload-speeding-wheel"></div>
  </div>
);
